module.exports = __webpack_public_path__ + "img/b0.38a0f1d2.png";